import {http, onSuccess, onFail} from "./http";

export const clientImportTimePadSettingsGet = (eventKey) =>
    http.get(`/api/cp/event/${eventKey}/client/importTimePad`)
        .then(onSuccess, onFail);

export const clientImportTimePadSettingsGetOne = (eventKey, id) =>
    http.get(`/api/cp/event/${eventKey}/client/importTimePad/${id}`)
        .then(onSuccess, onFail);

export const clientImportTimePadSettingsCreate = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/client/importTimePad`, data)
        .then(onSuccess, onFail);

export const clientImportTimePadSettingsUpdate = (eventKey, settingsId, data) =>
    http.post(`/api/cp/event/${eventKey}/client/importTimePad/${settingsId}`, data)
        .then(onSuccess, onFail);

export const clientImportTimePadSettingsDelete = (eventKey, settingsId) =>
    http.delete(`/api/cp/event/${eventKey}/client/importTimePad/${settingsId}`)
        .then(onSuccess, onFail);

export const clientImportTimePadEventsFetch = (eventKey, accessToken, organizationId) =>
    http.post(`/api/cp/event/${eventKey}/client/importTimePad/fetchEvents`, {accessToken, organizationId})
        .then(onSuccess, onFail);

export const clientImportTimePadEventFetch = (eventKey, accessToken, eventId) =>
    http.post(`/api/cp/event/${eventKey}/client/importTimePad/fetchEvent/${eventId}`, {accessToken})
        .then(onSuccess, onFail);

export const clientImportExecute = (eventKey, settingsId) =>
    http.post(`/api/cp/event/${eventKey}/client/importTimePad/${settingsId}/import`)
        .then(onSuccess, onFail);
